module.exports = __webpack_public_path__ + "media/site/images/products/saas_actionplan-screen1@2x-5fd12236e6dea4cc0c9a303944f3b2c3.png";